/*jslint node: true */
/*globals $ */
'use strict';

import globals from './globals';
import $ from 'jquery';

export default {
  scrollStart: 0,
  scrollDownEnd: 0,
  setText: function(objs, callback) {
    $.each(objs, function() {
      var s = $(this);

      var holder = s.closest('.select-holder');
      var parent = holder.find('.dropdown');
      var select = parent.find('.select');
      var suffix = holder.find('select').data('text');
      var emptyText = holder.find('select').data('emptyvalue');

      var selectedText = parent.find('.selected');
      var triggerText = parent.prev('.trigger').find('span');

      const selectHeight = holder.find('.trigger').outerHeight() || 42;

      var text = [];

      holder.find('option:selected').each(function() {
        if ($(this).val() !== '') text.push($(this).text());
      });

      if ( text.length > 1 && suffix && $('.search form').length > 0 && !s.parents('.brands').length ) {
        text = text.length + ' ' + suffix;
      } else if (text.length === 1) {
        text = text[0];
      }

      //If dropdown has no selection. The primary source for a text shown in the dropdown is the select element's attribute 'data-emptytext'.
      //If this attribute is not set value is read from the select element's first option element.
      else if (text.length === 0) {
        if (typeof emptyText === 'string' && emptyText.length > 0) {
          text = emptyText;
        } else {
          text = parent
            .parent('div')
            .find('.native-select')
            .find('option[value=""]')
            .eq(0)
            .text();
        }
      } else {
        text = text.join(', ');
      }

      selectedText.html(text);
      triggerText.html(text);

      if (!holder.find('select').prop('multiple')) {
        select
          .removeClass('open')
          .stop(true, true)
          .animate(
            {
              height: `${selectHeight}px`,
            },
            250,
          );
        parent.prev('.select').removeClass('triggered');
      }
    });

    if (callback && typeof callback === 'function') callback();
  },
  setEvents: function() {
    var interfaceSrc = false;
    var dropdown = $('.dropdown');

    window.onmousemove = () => {
      interfaceSrc = 'mouse';
    };

    dropdown
      .find('.select label')
      .on('mouseover', function() {
        if (interfaceSrc !== 'keyboard') {
          dropdown.find('.select label').removeClass('hover');
          $(this).addClass('hover');
        }
      })
      .on('mouseout', () => {
        if (interfaceSrc !== 'keyboard') {
          dropdown.find('.select label').removeClass('hover');
        }
      });
  },

  /**
   * Opens dropdown element
   *
   * @param {object} options options object
   * @param {JQuery} options.selectElement select element as jQuery object
   * @param {JQuery} options.dropdownElement dropdown element as jQuery object
   * @param {object} options.settings settings option
   * @param {Event} options.clickEvent mouse click event
   */
  openDropdown(options) {
    const { selectElement, dropdownElement, clickEvent } = options;

    const windowHeight = $(window).outerHeight() + $(window).scrollTop();

    let optionsHeight = windowHeight - dropdownElement.offset().top - dropdownElement.height() - 60;
    const holder = selectElement.closest('.select-holder');

    const globalDropdowns = $('body')
      .find('.selected')
      .not(clickEvent);
    const globalDropdownParents = globalDropdowns.closest('.select-holder').find('.dropdown');
    const globalSelects = globalDropdowns.closest('.select-holder').find('.select');

    const globalSelectsHeight = globalSelects.outerHeight() || 42;

    const optionsSumHeight = holder.find('.option:not(.hidden)').find('label').length * 34 + globalSelectsHeight;

    globalSelects
      .removeClass('open')
      .stop(true, true)
      .animate({ height: globalSelectsHeight }, 250);

    globalDropdownParents.prev('.select').removeClass('triggered');

    if (!holder.find('select').prop('disabled')) {
      if (holder.find('select').prop('multiple')) {
        selectElement.addClass('multiple');
      }

      if (optionsSumHeight < optionsHeight) {
        optionsHeight = optionsSumHeight;
      } else if (optionsHeight < 300) {
        if (optionsSumHeight < 300) {
          optionsHeight = optionsSumHeight;
        } else {
          optionsHeight = 300;
        }
      }

      var bottomCheckPoint = this.calculateBottomCheckpoint();

      if (dropdownElement.offset().top + optionsHeight > bottomCheckPoint) {
        if (
          dropdownElement.offset().top - optionsHeight > $('header').offset().top + $('header').outerHeight() &&
          dropdownElement.offset().top - $(window).scrollTop() > 300
        ) {
          selectElement.addClass('top').css({
            top: '-' + optionsHeight + 'px',
          });
        }
      }

      selectElement
        .addClass('open')
        .stop(true, true)
        .animate(
          {
            height: optionsHeight + 'px',
          },
          250,
        );
      dropdownElement.prev('.select').addClass('triggered');
    }
  },

  /**
   * Close dropdown element
   *
   * @param {object} options options object
   * @param {JQuery} options.selectElement select element as jQuery object
   * @param {JQuery} options.dropdownElement dropdown element as jQuery object
   * @param {object} options.settings settings option
   * @param {Event} options.clickEvent mouse click event
   */
  closeDropdown(options) {
    const { selectElement, dropdownElement } = options;

    const selectHeight = dropdownElement.closest('.select-holder').find('.trigger').outerHeight() || 42;

    selectElement.stop(true, true).animate(
      {
        height: `${selectHeight}px`,
      },
      250,
      () => {
        selectElement.removeClass('open');
      },
    );

    dropdownElement.prev('.select').removeClass('triggered');
    selectElement.css('top', 'auto');
  },

  calculateBottomCheckpoint() {
    if ($('.dropdown-checkpoint-holder').length > 0 && !$('body').hasClass('bmw-store') && !$('body').hasClass('honk-search')) {
      var bottom = $('.dropdown-checkpoint-holder').offset().top + $('.dropdown-checkpoint-holder').outerHeight();

      if (bottom > $(window).outerHeight()) {
        return $(window).outerHeight();
      } else {
        return bottom;
      }
    } else {
      return $(document).outerHeight();
    }
  },

  bindClicks: function(holder, settings, callback) {
    const _this = this;
    const dropdown = holder.find('.dropdown');

    dropdown.find('.selector').on('click', function(e) {
      e.stopPropagation();

      var parent = $(this).closest('.dropdown');
      var select = parent.find('.select');

      const selectHeight = parent.closest('.select-holder').find('.trigger').outerHeight() || 42;

      select
        .removeClass('open')
        .stop(true, true)
        .animate(
          {
            height: `${selectHeight}px`,
          },
          250,
          'swing',
          function() {
            select.removeClass('top').css({
              top: 'auto',
            });
          },
        );

      parent.prev('.select').removeClass('triggered');
    });

    dropdown.find('.selected').on('click', function(clickEvent) {
      clickEvent.stopPropagation();

      const selectElement = $(this).parent('.select');
      const dropdownElement = selectElement.parent('.dropdown');

      if (selectElement.hasClass('open')) {
        _this.closeDropdown({ selectElement, dropdownElement, settings, clickEvent });
      } else {
        _this.openDropdown({ selectElement, dropdownElement, settings, clickEvent });
      }
    });

    // Bind events for the dropdown options

    _this.setEvents();

    _this.setText(dropdown.find('input'));

    holder.find('select').on('change', function(e) {
      e.stopPropagation();

      const input = $(this);

      _this.setText(input, callback);
    });

    if (callback && typeof callback === 'function') {
      callback();
    }
  },
  setControls: function(objs) {
    const _this = this;

    if (objs && !(objs instanceof $)) objs = $(objs); // convert to jQuery object if needed

    objs.each(function() {
      var label = $(this).find('label');

      label.on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        var input = $(this).find('input:not([disabled])');
        var holder = input.closest('.select-holder');

        if (input.attr('type') === 'radio') {
          holder.find('input').prop('checked', false);
          input.prop('checked', true);
        } else {
          if (input.prop('checked')) input.prop('checked', false);
          else input.prop('checked', true);
        }

        holder
          .find('select option[value="' + input.val() + '"]')
          .prop('selected', input.is(':checked'))
          .trigger('change');

        _this.setText($(this));
      });

      _this.setText(label);
    });
  },
  /**
   * Turn native select elements into styled dropdown components
   * @param {Object} customSettings optional setting parameters
   * @param {string} customSettings.height optional css style attribute for element height. Default is 42px
   * @param {(string|HTMLElement|jQuery)} customSettings.custom optional element, selector or jQuery object. If only a particular select or selects need to be initialized, use this to locate them
   * @param {function} callback - is called once creating the dropdown is finished
   */
  create: function(customSettings, callback) {
    const _this = this;

    let settings = {
      height: '42px',
    };

    if (typeof customSettings === 'object') {
      settings = Object.assign(settings, customSettings);
    }

    $(settings.custom || 'select:not(#branch-bar__f-branch-selector):not(.remultiselect):not(.ignore-dropdown)').each(function() {
      const self = $(this);
      if (self.closest('.native-select').length < 1) {
        const tmpl = `<div class="select-holder">
              <div class="native-select"></div>
              <div class="select trigger"><span class="option"></span></div>
              <div class="dropdown">
                  <div class="select"><span class="selected"></span>
                      <div class="holder"></div>
                  </div>
              </div>
          </div>`;

        self.before(tmpl);

        var type = self.prop('multiple') ? 'checkbox' : 'radio';
        var multiple = self.prop('multiple');
        var holder = self.prev('.select-holder');
        var nativeSelect = holder.find('.native-select');
        var triggerText = holder.find('.trigger span');
        var defaultText = holder.find('.dropdown .selected');
        var optionHolder = holder.find('.dropdown .holder');
        var optgroups = [];

        self.attr('tabindex', '-1');

        if (typeof self.attr('class') !== 'undefined' && self.attr('class') !== '')
          holder.closest('.form-group').attr('class', 'form-group ' + self.attr('class').replace('form-control', ''));

        if (self.prop('required')) holder.addClass('stage-required');

        if (self.hasClass('form-control')) holder.addClass('form-control');

        if (self.prop('disabled')) holder.closest('.form-group').addClass('disabled');

        self.find('option').each(function() {
          var text = $(this).html();
          var val = $(this).val();
          var option = $('<span class="option" />');
          option.append('<label class="' + type + '" />');
          var label = option.find('label');
          var input = $('<input />');

          if ($(this).parent('optgroup').length > 0) {
            var optgroupObj = $(this).parent('optgroup');

            if ($.inArray(optgroupObj.attr('label'), optgroups) < 0) {
              var optgroup = $('<strong class="optgroup">' + optgroupObj.attr('label') + '</strong>');

              optgroupObj.each(() => {
                $(this.attributes).each(() => {
                  optgroup.attr(this.name, this.value);
                });
              });

              optionHolder.append(optgroup);
              optgroups.push(optgroupObj.attr('label'));
            }
          }

          if ($(this).prop('selected')) {
            input.prop('checked', true);
          }

          if (val === '' && !multiple) {
            triggerText.text(text);
            defaultText.html(text);

            input.attr('type', type);

            $(this.attributes).each(function(i, attr) {
              input.attr(attr.name, attr.value);
            });

            label.append(input);
            label.append('<span>' + text + '</span>');
            optionHolder.append(option);
          } else if (val === '') {
            triggerText.text(text);
            defaultText.html(text);
          } else {
            input.attr('type', type);

            $(this.attributes).each(function(i, attr) {
              input.attr(attr.name, attr.value);
            });

            label.append(input);
            label.append('<span>' + text + '</span>');
            optionHolder.append(option);
          }
        });

        if (multiple) optionHolder.after('<span class="selector">Valitse</span>');

        self.appendTo(nativeSelect);
        //localStorage.setItem(window.location.pathname + 'select/' + holder.find('select').attr('name'),holder[0].outerHTML);

        if (globals.isMobileOS) $('.native-select').show();

        holder.find('.loader-holder').remove();

        _this.bindClicks(holder, settings, callback);
      }
    });

    _this.setControls($('.select-holder'));
  },
  init: function(callback) {
    const _this = this;

    window.addEventListener('click', function(e) {
      $('.select')
        .removeClass('triggered open')
        .css({ top: 'auto', height: 'auto' });
    });

    if (!$('body').hasClass('app')) {
      _this.create(false, callback);
    }
  },
};
